export const FIRM_DOCUMENTS_LABELS = {
  allDocuments: 'All Documents',
  analyzeCapTable: 'Analyze Cap Table',
  analyzeFinancials: 'Analyze Financials',
  bulkActions: 'Bulk Actions',
  bulkAnalyzeCapTable: 'Analyze Cap Table',
  bulkAnalyzeFinancials: 'Analyze Financials',
  bulkCopy: 'Copy to Another Measurement Date',
  bulkDelete: 'Delete Selected',
  bulkDownload: 'Download Selected',
  clearDocumentSearch: 'Clear document search',
  exitFullScreen: 'Exit Fullscreen',
  fileType: 'File Type',
  filterBy: 'Filter By',
  findDocuments: 'Find document',
  findDocumentsInAllDocuments: 'Find documents',
  findDocumentsInCompany: (companyName: string) => `Find documents in ${companyName}`,
  fullScreen: 'Fullscreen',
  noDocumentsAvailableDescription: 'Try a different company or measurement date.',
  noDocumentsAvailableTitle: 'No documents available',
  noMatchingDocumentsDescription: 'Clear the search, adjust filters, or choose another measurement date.',
  noMatchingDocumentsTitle: 'No documents found',
  noSearchSuggestions: 'No matching files found',
  referenceType: 'Reference Type',
  searchSuggestionsLoading: 'Searching documents...',
  selectAllDocuments: 'Select all documents',
  sortAndFilter: 'Sort & Filter',
  sortAndFilterWithCount: (activeFilterCount: number) => `Sort & Filter (${activeFilterCount})`,
  sortBy: 'Sort By',
  source: 'Source',
  sourcePlaceholder: 'Select Source',
  submitDocumentSearch: 'Search documents',
  tertiaryNavigationAriaLabel: 'Documents views',
  unknownCompany: 'Unknown company',
} as const;

export const FIRM_DOCUMENTS_PANE_WIDTHS = {
  defaultCompanyListWidth: 350,
  minCompanyListWidth: 240,
  minDocumentsListWidth: 360,
} as const;

export const FIRM_DOCUMENTS_QUERY_PARAMS = {
  documentFileType: 'file_type',
  documentOrdering: 'document_ordering',
  documentReferenceType: 'reference_object_type',
  documentSearch: 'search',
  documentSource: 'source',
  documentUploadedBy: 'uploaded_by',
} as const;

export const FIRM_DOCUMENTS_DOCUMENT_ORDERINGS = [
  {
    label: 'Upload Date',
    value: '-uploaded_date',
  },
  {
    label: 'Filename',
    value: 'filename',
  },
] as const;

export const FIRM_DOCUMENTS_DOCUMENT_ORDERING_VALUES = [
  '-uploaded_date',
  'uploaded_date',
  'filename',
  '-filename',
] as const;

export const FIRM_DOCUMENTS_DOCUMENT_SOURCES = [
  {
    label: 'Document Request',
    value: 'document_request',
  },
  {
    label: 'Generated Document',
    value: 'generation_job',
  },
  {
    label: 'User',
    value: 'user',
  },
] as const;

export const FIRM_DOCUMENTS_SUPPORTED_REFERENCE_OPTIONS = [
  {
    label: 'Cap Table',
    value: 'ct',
  },
  {
    label: 'Financials',
    value: 'fi',
  },
  {
    label: 'Fund Ownership',
    value: 'fo',
  },
] as const;
